<template>
    <div>

        <table class="table table-sm table-striped no-margin">
            <thead>
            <tr>
                <th class="col-xs-12 col-sm-4 col-md-6">
                    Item
                </th>
                <th class="col-xs-6 col-sm-4 col-md-3">
                    Price
                </th>
                <th class="col-xs-2 col-sm-4 col-md-3">Quantity</th>
            </tr>
            </thead>
            <tbody class="merchandise__options">
            <tr>
                <td>{{ entity.name }}</td>
                <td>{{ entity.price_display }}</td>
                <td>
                    <plus-mins-control class="float-right"
                                       :min="0"
                                       :max="10"
                                       v-model="quantity"></plus-mins-control>
                </td>
            </tr>
            </tbody>
        </table>
        <input v-if="quantity>0 && showButton"
               type="submit"
               value="Add to basket"
               class="btn btn-ar btn-block btn-success"
               @click="addToBasket"
        >
    </div>
</template>
<script>
//Does this need to be tied to GiftCards specifically, or can we make it reusable?
import PlusMinsControl from "./PlusMinsControl.vue";

export default {
    components: {
        PlusMinsControl
    },
    props: {
        showButton: {
            default: () => true,
            type: Boolean
        },
        entity: {
            type: Object
        },
        theme: {
            type: String,
            default: 'bs3'
        }
    },
    data() {
        return {
            quantity: 0,
        }
    },
    watch: {
        quantity() {
            this.$emit('input', this.quantity);
        }
    },
    created() {
        var urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('quantity')) {
            this.quantity = parseInt(urlParams.get('quantity'));
        } else {
            this.quantity = 0;
        }
    },

    methods: {
        addToBasket() {
            let url = window.location.origin + `/gift-cards/${this.entity.id}/credit?quantity=${this.quantity}`;

            if (!this.userProp) {
                //there is no user take them to the page to get more info
                window.location.href = url;
            }
        }
    }
}
</script>
<style lang="scss">

.align-middle {
    vertical-align: middle !important;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/QuantityPicker.vue